import { Component, Input, AfterViewChecked, ViewEncapsulation, AfterViewInit } from '@angular/core';
import { MathJaxService } from '../../../services/mathjax.service';

@Component({
  selector: 'app-explicacion',
  templateUrl: './explicacion.component.html',
  standalone: false,
  encapsulation: ViewEncapsulation.None,
  providers: [
    MathJaxService
  ]
})
export class ExplicacionComponent implements AfterViewChecked, AfterViewInit {
  @Input() visible = false;
  @Input() title = '';
  @Input() contenido = '';
  @Input() onClose!: () => void;

  private alreadyRendered = false;

  constructor(private mathJaxService: MathJaxService) { }

  ngAfterViewChecked(): void {
    // Renderiza solo una vez por apertura
    if (this.visible && !this.alreadyRendered) {
      this.mathJaxService.renderMath();
      this.alreadyRendered = true;
    }

    // Reinicia la bandera cuando el diálogo se cierra
    if (!this.visible && this.alreadyRendered) {
      this.alreadyRendered = false;
    }
  }

  ngAfterViewInit() {
    const MathJax = (window as any).MathJax;
    if (MathJax?.typesetPromise) {
      MathJax.typesetPromise()
        .then(() => console.log('MathJax v3 typeset complete'))
        .catch((err: any) => console.error('MathJax typeset error:', err));
    }
  }
}
